import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import appRoutes from '../../configs/AppRoutes';
import { callCommonAction } from '../../redux/Common/CommonReducer';
import { sendRequest } from '../../apis/APIs';
import { useLocation } from 'react-router-dom';
const Header = () => {
  const { isAsideOpen, user, pageData, isLoggedIn } = useSelector((state) => state.common);

  console.log(user,"useruseruser")
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [fileName, setFileName] = useState('');
  const [filePreview, setFilePreview] = useState(null);
  const [userDetail, setUserDetail] = useState({
    name: '',
    email: '',
    phone_no: '',
    file: '',
    current_password: '',
    password: '',
    password_confirmation: ''
  });
  const hiddenRoutes = ["/login", "/forgot-password", "/reset-password"];
  useEffect(() => {
    document.body.classList.toggle("sidebar-hide", isAsideOpen);
    return () => {
      document.body.classList.remove("sidebar-hide");
    };
  }, [isAsideOpen]);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };



  useEffect(() => {
    getUserData();
  }, []);

  useEffect(() => {
  if (user) {
    getUserData();
  }
}, [user]);

  const getUserData = async () => {
    try {
      const res = await sendRequest('/user/data', 'GET');
      if (res.data.type === 'success') {
        setUserDetail((prev) => ({
          ...prev,
          name: res?.data?.data?.name,
          email: res?.data?.data?.email,
          phone_no: res?.data?.data?.phone_no,
        }));
        if (res?.data?.data?.full_file_path) {
          setFilePreview(res?.data?.data?.full_file_path);
        }
      } else {
        // Optional: Handle the case where response is not 'success'
        console.error("Failed to fetch user data", res.data.message);
      }
    } catch (error) {
      // Log the actual error
      console.error("Error fetching user data:", error);
    }
  };

  const storedUserData = localStorage.getItem('user');
  // Parse the JSON string to get the JavaScript object
  const storedUser = storedUserData ? JSON.parse(storedUserData) : null;

  // Access the ID if storedUser exists
  const userId = storedUser ? storedUser.id : null;




  useEffect(() => {

    // Skip API call if the route is one of the excluded ones
    if (['/login', '/forgot-password', '/reset-password'].includes(location.pathname)) {
      return; // Don't make the API call on these routes
    }

    const getUserList = async () => {
      try {
        const res = await sendRequest(`/user/data/${userId}`, 'GET');
        if (res.data.type === "success") {
          const userData = res.data.data;

          if (userData.status === "0" || userData.status === 0 || userData.is_deleted === 1 || userData.is_deleted === "1") {
            localStorage.clear();
            window.location.href = '/login';
          }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    getUserList(); // Call on every route change
  }, [location.pathname]); // ⬅ triggers whenever route changes



  const handleImageClick = () => {
    if (!user) {
      navigate(appRoutes.loginPageRoute);
    } else if (user && pageData?.id) {
      if (window.location.pathname === appRoutes.viewPageDetailPageRoute) {
        window.scrollTo(0, 0);
      } else {
        navigate(appRoutes.viewPageDetailPageRoute);
      }
    } else {
      navigate(appRoutes.createFriendPageRoute);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    dispatch(callCommonAction({ isLoggedIn: false, token: null, user: null }));
    navigate(appRoutes.loginPageRoute); // ensures no query params are carried over
  };

  // Close dropdown when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // ✅ Do this AFTER all hooks
  if (hiddenRoutes.includes(location.pathname)) {
    return null;
  }

  return (
    <>
      <div className={`side-drawer-wrapper ${isOpen ? 'open' : ''}`} />
      <header className="container-fluid bg-transparent w-100 py-2 px-2">
        <div className="row justify-content-between align-items-center py-2">
          <div className="col">
            <img
              className="header-logo"
              onClick={(e) => {
                e.preventDefault();
                navigate(appRoutes.listProposalRoute);
              }}
              src={process.env.PUBLIC_URL + '/assets/images/image.png'}
              alt="App Logo"
          style={{ cursor: 'pointer', height: '40px', width: 'auto' }} // Adjust height here
            />
          </div>
          <div className="col text-end position-relative" ref={dropdownRef}>
            <div class="dropdown">
              <a class="no-caret" href="#" role="button" id="profileActions" data-bs-toggle="dropdown" aria-expanded="false">
                <span className="d-inline-flex align-items-center">
                  {console.log(filePreview,"filePreviewfilePreview")}
                  {user?.full_file_path && user?.full_file_path !== 'https://api.cad.kleeberg.com/storage/' ? (
                    <img
                      className="user-img"
                      src={filePreview}
                      alt="User"
                    />

                  ) : (
                    <img
                      className="user-img"
                      src={`${process.env.PUBLIC_URL}/assets/images/avatar_placeholder.png`}
                      alt="Default"
                    />
                  )}
                  <span className="user-name">{user?.name}</span>
                  <iconify-icon icon="lsicon:down-filled" class="fs-6 text-body"></iconify-icon>
                </span>



              </a>
              <ul class="dropdown-menu  dropdown-menu-end" aria-labelledby="profileActions">
                <li><a class="dropdown-item" href="" onClick={(e) => { e.preventDefault(); setIsOpen(false); navigate(appRoutes.profilePageRoute); }}>
                  <span className="d-flex align-items-center gap-1">
                    <iconify-icon icon="bxs:user" class="fs-6 yellow"></iconify-icon> My Profile
                  </span>
                </a>
                </li>


                {window.location.pathname !== '/proposal-list' && (
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(appRoutes.listProposalRoute);
                      }}
                    >
                      <span className="d-flex align-items-center gap-1">
                        <iconify-icon icon="basil:document-solid" class="fs-6 yellow"></iconify-icon>
                        My Documents
                      </span>
                    </a>
                  </li>
                )}


                <li><a class="dropdown-item" href="" onClick={(e) => { e.preventDefault(); setIsOpen(false); handleLogout(); }}>
                  <span className="d-flex align-items-center gap-1">
                    <iconify-icon icon="ri:logout-circle-r-line" class="fs-6 yellow"></iconify-icon> Logout
                  </span>
                </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
